/* src/app/pages/home/header/component.scss */
.header_area {
  border-bottom: 2px solid rgb(248, 179, 179);
}
.nav-item {
  font-size: 20px;
}
img {
  width: 200px;
  height: auto;
}
#mat-raised-button {
  border-radius: 40px;
}
@media screen and (max-width: 576px) {
  .btnFloatdiv {
    float: left !important;
  }
  .btnFloatdivChip {
    float: left !important;
  }
}
@media screen and (min-width: 576px) {
  .btnFloatdiv {
    float: right !important;
  }
  .btnFloatdivChip {
    float: right !important;
  }
}
/*# sourceMappingURL=component.css.map */
